import { FC, useEffect } from 'react';
import { XMarkIcon as CloseIcon } from '@heroicons/react/24/solid';
import ReactModal, { Props as ReactModalProps } from 'react-modal';
import useMediaQuery from 'helpers/hooks/useMediaQuery';
//import useScrollBlock from 'helpers/hooks/useScrollBlock';
import { largeDesktop, tablet } from 'helpers/utils/screensizes';

export interface Props extends ReactModalProps {
  closeButton?: boolean;
  maxWidth?: any;
}

const Modal: FC<Props> = ({ children, style, preventScroll, closeButton, maxWidth, className = '', ...props }) => {
  const [isDesktopSize] = useMediaQuery(largeDesktop);
  const [isTabletSize] = useMediaQuery(tablet);

  //const { blockScroll } = useScrollBlock();
  const modalStyle: ReactModalProps['style'] = {
    overlay: {
      zIndex: 51,
      backgroundColor: 'rgba(127 ,127, 127, .3)',
      ...style?.overlay,
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      maxWidth: isDesktopSize ? 700 : !isTabletSize ? '90%' :  500,
      position: 'relative',
      padding: 0,
      ...style?.content,
    },
  };

  useEffect(() => {
    if (props.isOpen) {
      document.body.style.overflowY = 'hidden';
      document.body.style.overflowX = 'hidden';
      document.body.classList.add('ReactModal__Body--open');
    } else {
      document.body.style.overflowY = '';
      document.body.style.overflowX = '';
      document.body.classList.remove('ReactModal__Body--open');
    }

    return () => {
      document.body.style.overflowY = '';
      document.body.style.overflowX = '';
      document.body.classList.remove('ReactModal__Body--open');
    };
  }, [props.isOpen]);

  return (
    <ReactModal
      {...props}
      ariaHideApp={false}
      style={modalStyle}
      preventScroll={preventScroll}
      className={`${className} relative`}
    >
      {closeButton && (
        <CloseIcon
          className="z-50 absolute right-20 top-20 h-32 w-32 cursor-pointer text-secondary-black"
          onClick={props.onRequestClose}
        />
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
